module.exports = {"vesselName":"","vessel":"","items":[],"user":"","validateErrors":[],"successMessage":{},"loadingPortName":""}


//////////////////
// WEBPACK FOOTER
// ./app/mocks/vessel/size.json
// module id = 651
// module chunks = 0